<template>
  <div class="bottomBar">
    <div class="bottomMenuWrap">
      <el-scrollbar style="width: 100%; padding-right: 17px">
        <div class="partLineAll">
          <div
            :class="{ partLine: true, active: i == nowFloor }"
            v-for="(item, i) in resData"
            :key="i"
            @click="changePart(i)"
          >
            <div class="partLine-title">
              <div class="edelgS">
                {{ item.groupName == null ? "默认一级分组" : item.groupName }}
              </div>
              <el-popover
                placement="top"
                title=""
                width="50"
                trigger="click"
                class="myPopUp"
              >
                <div class="popupClick" @click="openPartRename(i)">重命名</div>
                <div class="popupClick" v-if="i!=0" @click="deletePart">删除</div>
                <i
                  class="el-icon-more"
                  slot="reference"
                  @click.stop="partRenameActive = i"
                ></i>
              </el-popover>
            </div>
          </div>
        </div>
      </el-scrollbar>

      <el-tooltip
        class="item"
        effect="dark"
        content="创建一级分组"
        placement="top"
      >
        <div class="rightBtn" @click="openPart()">
          <i class="el-icon-plus"></i>
        </div>
      </el-tooltip>
      <el-dialog
        title="新建一级分组"
        :visible.sync="dialogPartVisible"
        width="50%"
      >
        <el-input
          v-model="partTitle"
          placeholder="请输入一级分组的名称"
        ></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            @click="addPart()"
            :disabled="partTitle == ''"
            >确 定</el-button
          >
        </span>
      </el-dialog>

      <el-dialog
        title="分组重命名"
        :visible.sync="partRenameVisible"
        width="50%"
      >
        <el-input
          v-model="partName"
          placeholder="请输入一级分组的名称"
        ></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            @click="partRename()"
            :disabled="partName == ''"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <div class="bottomMenuScrollWrap">
      <div class="scrollWrap">
        <el-scrollbar class="page-scroll">
          <div class="bottomMenuContent">
            <div class="leftBottom" v-if="resData.length > 0">
              <draggable
                v-model="resData[active].panos"
                @update="datadragEnd"
                :options="{ animation: 500 }"
              >
                <transition-group>
                  <div
                    class="panoItem"
                    v-for="(item, i) in resData[active].panos"
                    :key="item.physicalFile.id"
                  >
                    <div
                      :class="[
                        'topWrap',
                        nowPanoItemIndex === i && nowFloor == active
                          ? 'active'
                          : '',
                      ]"
                    >
                      <img
                        :src="item.physicalFile.thumbnailUrl"
                        @click="changePano(i)"
                      />
                      <div class="editbtn" @click="showEditOptions(i)">
                        <i class="el-icon-more"></i>
                        <div
                          :class="[
                            'editOptions',
                            nowEditOptionsNum === i ? 'active' : '',
                          ]"
                        >
                          <div @click="showRenameTip(i)">重命名</div>
                          <div @click="deletePanoItem(i)">删除</div>
                          <!-- <div @click="changeThumBPic(i)">替换封面</div> -->
                        </div>
                      </div>
                    </div>
                    <div class="name">{{ item.physicalFile.fileName }}</div>
                  </div>

                </transition-group>
              </draggable>
            </div>
            <div class="panoList_add" @click="showAddPanoList()">
              <img src="images/addArrow.png" alt />
              添加场景
            </div>
            <my-database
              v-if="dialog"
              :type="type"
              :closeFunc="close"
              :submitFunc="add"
            ></my-database>
          </div>
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>
<style>
.bottomMenuWrap .el-scrollbar__wrap {
  overflow-x: hidden;
  overflow-y: hidden;
}
.el-popover {
  min-width: 90px !important;
}
.bottomBar .el-scrollbar__bar.is-horizontal{
  height: 10px;
}
</style>
<style scoped>
.bottomBar {
  width: calc(100vw - 280px);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 150px;
  flex: 0 0 150px;
  padding: 10px;
  box-sizing: border-box;
  border-color: #4b4b4b #000 #000 #4b4b4b;
  border-style: solid;
  border-width: 1px;
  background-color: #2c2c2c;
  /* z-index:10000; */
}
.partScroll {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
}
.bottomMenuWrap {
  width: 100%;
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 35px;
  flex: 0 0 35px;
  background-color: #2c2c2c;
  box-sizing: border-box;
  overflow: hidden;
}

.partLineAll {
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
}

.partLine {
  /* width: 150px; */
  height: 35px;
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-end;
  margin-right: 10px;
  font-size: 12px;
}

.partLine-title {
  height: 29px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 15px;
  border-radius: 3px 3px 0px 0px;
  background-color: rgb(48, 48, 48);

  cursor: pointer;
}

.partLine.active .partLine-title {
  background: #333;
}
.edelgS,
.partLine i {
  display: inline-block;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-wrap: normal;
  color: rgb(119, 119, 119);
  cursor: default;
}
.partLine.active .edelgS,
.partLine.active i {
  color: rgb(255, 255, 255);
}
.popupClick {
  cursor: pointer;
}
.popupClick:hover {
  color: #999;
}
.myPopUp i{
  height: 28px;
  width: 30px;
  display: block;
  line-height: 28px;
  cursor: pointer;
}

.bottomMenuWrap .rightBtn {
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  margin: 8px 8px 0 8px;
  background-color: rgb(75, 75, 75);
  border-radius: 3px;

  font-size: 14px;
  cursor: pointer;
}

.bottomMenuScrollWrap {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  /* overflow-y: hidden; */
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
}
.scrollWrap {
  position: relative;
  /* width: calc(100vw - 300px); */
  height: 100%;
  overflow-y: hidden;
  overflow-x: auto;
}
.bottomMenuContent {
  position: relative;
  display: flex;
  -webkit-box-direction: normal;
  -webkit-box-orient: horizontal;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
  height: 110px;
  padding-top: 8px;
  background: #333;
}
.bottomMenuContent .panoList_add {
  -webkit-box-orient: vertical;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 70px;
  flex: 0 0 70px;
  height: 70px;
  color: #aaa;
  border: 1px dotted #777;
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-direction: normal;
}
.bottomMenuContent .panoList_add img {
  width: 18px;
  height: 18px;
  margin-bottom: 10px;
}

.bottomMenuContent .leftBottom {
  width: auto;
  height: 100px;
  position: relative;
}
.bottomMenuContent .leftBottom > div {
  width: auto;
  height: 100px;
  position: relative;
}
.bottomMenuContent .leftBottom > div > span {
  position: relative;
  display: flex;
  -webkit-box-direction: normal;
  -webkit-box-orient: horizontal;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
  height: 100px;
}
.bottomMenuContent .panoItem {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 70px;
  flex: 0 0 70px;
  position: relative;
  margin-right: 10px;
  margin-left: 10px;
  color: #aaa;
  font-size: 12px;
}
.bottomMenuContent .panoItem .topWrap {
  position: relative;
  width: 70px;
  height: 70px;
  margin-bottom: 8px;
  background-color: #4b4b4b;
  -webkit-box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.7);
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.7);
  cursor: pointer;
}
.bottomMenuContent .topWrap.active {
  border: 2px solid #fbd14b;
}
.bottomMenuContent .panoItem .topWrap img {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.bottomMenuContent .panoItem .topWrap .editbtn {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 20px;
  height: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  cursor: pointer;
}
.bottomMenuContent .panoItem .topWrap .editbtn i {
  font-size: 15px;
  line-height: 20px;
  text-align: center;
}
.bottomMenuContent .editbtn .editOptions {
  background-color: #fff;
  -webkit-box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.5);
  border-radius: 3px;
  padding: 5px 5px;
  position: absolute;
  right: -60px;
  top: -50px;
  z-index: 99;
  display: none;
  font-size: 12px;
  line-height: 14px;
}
.bottomMenuContent .editbtn .editOptions.active {
  display: block;
}
.bottomMenuContent .editbtn .editOptions div {
  padding: 3px 0;
  color: #333;
  cursor: pointer;
  text-align: center;
}
.bottomMenuContent .editOptions div:hover {
  color: blue;
}
.bottomMenuContent .panoItem .name {
  width: 70px;
  text-align: center;
  cursor: default;
  line-height: 16px;
  font-size: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
<script>
import MyDatabase from '../database.vue'
import draggable from 'vuedraggable'
export default {
  name: '',
  components: {
    MyDatabase: MyDatabase,
    draggable
  },
  props: ['nowPanoItemIndex', 'nowFloor', 'resData'],
  computed: {

  },
  data() {
    return {
      dialog: false,
      type: '1',
      nowEditOptionsNum: -1,
      EditOptionsIsShow: false,
      dialogPartVisible: false,
      partTitle: '',
      active: 0,
      partName: '',
      partRenameActive: 0,
      partRenameVisible: false,
      res: []
    }
  },
  created() {
    // console.log(this.panoInfos)
  },
  mounted() {
    console.log(this.resData)
    this.res = this.resData
  },
  methods: {
    datadragEnd(evt) {
      evt.preventDefault()
      console.log('拖动前的索引 :' + evt.oldIndex)
      console.log('拖动后的索引 :' + evt.newIndex)
      this.sortPanos(this.resData[this.nowFloor].panos)
    },
    sortPanos(arr) {
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i
      }
    },
    showAddPanoList() {
      this.dialog = true
    },
    changePano(num) {
      // if(this.active!== this.nowFloor){
      //   let i = this.nowFloor;
      //   this.$parent.$parent.changeNowFloor(this.active)
      //   this.$parent.$parent.changeResInfo(i);
      // }
      // this.$parent.hasInit = false;
      this.$parent.changePanoMat(num)
    },
    openPart() {
      this.dialogPartVisible = true
    },
    addPart() {
      const json = JSON.parse(JSON.stringify(this.resData[0]))
      json.firstSceneID = json.id
      json.id = '00000000-0000-0000-0000-000000000000'
      json.groupName = this.partTitle
      json.panos = []
      json.model = null
      json.modelID = ''
      json.sandTableID = ''
      json.sandTable_Point.sandPoints = []
      json.sandTable_Point.sandTable = null
      console.log(json)
      this.resData.push(json)
      this.dialogPartVisible = false
    },
    changePart(i) {
      this.active = i
      this.$parent.$parent.changeResInfo(i)
      this.$parent.changePanoMatByFloor(0, this.active)
    },
    showEditOptions(num) {
      if (!this.EditOptionsIsShow) {
        this.nowEditOptionsNum = num
        this.EditOptionsIsShow = true
      } else {
        this.nowEditOptionsNum = -1
        this.EditOptionsIsShow = false
      }
    },
    showRenameTip(num) {
      this.$prompt('全景图重命名', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(({ value }) => {
          this.$message({
            type: 'success',
            message: '你的新名称是: ' + value
          })
          this.resData[this.nowFloor].panos[num].physicalFile.fileName = value
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          })
        })
    },
    deletePanoItem(num) {
      if (this.resData[this.nowFloor].panos.length >= 2) {
        this.$confirm(
          '此操作会将场景' +
            this.resData[this.nowFloor].panos[num].physicalFile.fileName +
            '下所有设置也都删除., 是否继续?',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
          .then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            var panoID = this.resData[this.nowFloor].panos[num].physicalFile.id
            this.resData[this.nowFloor].panos.splice(num, 1)
            if(this.resData[this.nowFloor].sandTable_Point.sandPoints != null) {
              var pointIndex = this.resData[this.nowFloor].sandTable_Point.sandPoints.findIndex(item => item.panoID === panoID)
              if(pointIndex >= 0) {
                this.resData[this.nowFloor].sandTable_Point.sandPoints.splice(pointIndex, 1)
                if(this.resData[this.nowFloor].sandTable_Point.sandPoints.length > pointIndex) {
                  this.$parent.$parent.changePanoEditInfos('sandPointActiveIndex', pointIndex)
                }else{
                  this.$parent.$parent.changePanoEditInfos('sandPointActiveIndex', pointIndex - 1)
                }
              }
            }
            // let pano =
            //this.resInfos = JSON.parse(JSON.stringify(this.resInfos));
            //this.resInfos.panos = json;
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      } else {
        this.$message({
          type: 'warning',
          message: '至少保留一张全景图'
        })
      }
    },
    close() {
      this.dialog = false
    },
    add(item) {
      if (this.resData[this.active].panos.length > 0) {
        for (var i = 0; i < item.length; i++) {
          var id = item[i].id
          var num = this.resData[this.active].panos.find(function (elem) {
            return elem.physicalFile.id === id
          })
          if (num === undefined) {
            var data = {
              fovDefault: 65,
              fovMax: 90,
              fovMin: 40,
              id: '00000000-0000-0000-0000-000000000000',
              lat: 0,
              lon: 270,
              posX: null,
              posY: null,
              posZ: null,
              sceneID: this.resData[this.active].id,
              screenPosX: null,
              screenPosY: null,
              status: 1,
              v_High: 90,
              v_Low: -90,
              sort: 0,
              hotPointlist: [],
              physicalFile: {
                createTime: item[i].createTime,
                fileFormat: item[i].fileFormat,
                fileName: item[i].fileName,
                filePath: item[i].filePath,
                fileSize: item[i].fileSize,
                hashValue: item[i].hashValue,
                id: item[i].id,
                status: item[i].status,
                thumbnailUrl: item[i].thumbnailUrl,
                type: item[i].type
              }
            }
            this.$set(
              this.resData[this.active].panos,
              this.resData[this.active].panos.length,
              data
            )
            this.sortPanos(this.resData[this.active].panos)
          }
        }
      } else {
        for (var i = 0; i < item.length; i++) {
          var id = item[i].id
          var num = this.resData[this.active].panos.find(function (elem) {
            return elem.physicalFile.id === id
          })
          if (num === undefined) {
            var data = {
              fovDefault: 65,
              fovMax: 90,
              fovMin: 40,
              id: '00000000-0000-0000-0000-000000000000',
              lat: 0,
              lon: 270,
              posX: null,
              posY: null,
              posZ: null,
              sceneID: this.resData[this.active].id,
              screenPosX: null,
              screenPosY: null,
              status: 1,
              v_High: 90,
              v_Low: -90,
              sort: 0,
              hotPointlist: [],
              physicalFile: {
                createTime: item[i].createTime,
                fileFormat: item[i].fileFormat,
                fileName: item[i].fileName,
                filePath: item[i].filePath,
                fileSize: item[i].fileSize,
                hashValue: item[i].hashValue,
                id: item[i].id,
                status: item[i].status,
                thumbnailUrl: item[i].thumbnailUrl,
                type: item[i].type
              }
            }
            this.$set(
              this.resData[this.active].panos,
              this.resData[this.active].panos.length,
              data
            )
            this.sortPanos(this.resData[this.active].panos)
          }
        }
        this.$parent.changePanoMatByFloor(0, this.active)
      }
    },
    openPartRename(i) {
      console.log(this.resData)
      this.partRenameActive = i
      this.partName = this.resData[i].groupName
      this.partRenameVisible = true
    },
    partRename() {
      debugger
      this.resData[this.partRenameActive].groupName = this.partName
      this.partRenameVisible = false
    },
    deletePart() {
      if (this.resData.length >= 2) {
        this.$confirm(
          '此操作会该分组' +
            this.resData[this.partRenameActive].groupName +
            '下所有设置也都删除., 是否继续?',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
          .then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            if(this.nowFloor == this.partRenameActive) {
              this.active = 0
              // this.$parent.$parent.changeResInfo(0);
              // this.$parent.changePanoMatByFloor(0,0)
              //this.resData = this.resData.splice(this.partRenameActive, 1);
              this.$parent.$parent.changeRes(this.partRenameActive)
            } else{
              this.$parent.$parent.changeRes2(this.partRenameActive)
            }

            // let pano =
            //this.resInfos = JSON.parse(JSON.stringify(this.resInfos));
            //this.resInfos.panos = json;
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      } else {
        this.$message({
          type: 'warning',
          message: '至少保留一个分组'
        })
      }
    }
  }
}
</script>
